import { inject, Injectable } from '@angular/core';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { Transporter } from '../models/transporter.model';
import { Observable, of } from 'rxjs';

export interface PageMetadata {
  description: string;
  author: string;
  keywords: string[];
  type: string;
  viewport: string;
}

const defaultMetadata: PageMetadata = {
  description: "BARY l'application des transporteurs",
  author: 'powered by Bary',
  keywords: [
    'transporteur',
    'BARY',
    'application',
    'chargeur',
    'devis',
    'quotation',
    'interface',
    'digital',
    'similes88',
    'commande',
    'transport',
    'marchandises',
    'colis',
    'palette',
    'um',
    'offre',
    'commerce',
    '60x80',
    '80x120',
    '100x120',
    '120x120',
  ],
  type: 'website',
  viewport: 'width=device-width, initial-scale=1, shrink-to-fit=no',
};

@Injectable({
  providedIn: 'root',
})
export class MetadataService {
  private metaTagService = inject(Meta);

  public updateMetadata(metadata: Partial<PageMetadata>, index: boolean = true): void {
    const pageMetadata: PageMetadata = { ...defaultMetadata, ...metadata };
    const metatags: MetaDefinition[] = this.generateMetaDefinitions(pageMetadata);
    this.metaTagService.addTags([
      ...metatags,
      { property: 'og:url', content: window.location.origin },
      { name: 'robots', content: index ? 'index, follow' : 'index' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1, shrink-to-fit=no' },
      { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
    ]);
  }

  private generateMetaDefinitions(metadata: PageMetadata): MetaDefinition[] {
    return [
      { name: 'description', content: metadata.description },
      { property: 'og:description', content: metadata.description },

      { name: 'keywords', content: metadata.keywords.join(', ') },

      { property: 'og:type', content: metadata.type },
      { property: 'og:image', content: metadata.type },
    ];
  }

  public updateMetadataForTransporter(transporter: Transporter): Observable<any> {
    // uniquement les éléments à surcharger
    this.updateMetadata({
      description: 'Nouveau ! Passez vos commandes de transport de marchandise routier en toutes simplicité avec ' + transporter.shopName,
    });
    return of();
  }
}
